export default "__VITE_ASSET__CM_SQv5Z__"